import MaterialTable from 'material-table';
import React from 'react';
import { Box } from '../../UI';
import tableIcons from '../../UI/icons';
import './custom.css'
import { Typography, Button } from '@material-ui/core';
import { display } from '@material-ui/system';
import PublishIcon from '@material-ui/icons/Publish';
import ImportExportIcon from '@material-ui/icons/ImportExport';

class Editable extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			columns: [],
			data: [],
		};
	}

	componentDidMount = () => {
		let columns = [
			{ title: 'Tenant', field: 'tenant' },
			{ title: 'Description', field: 'description' },
			{ title: 'Link', field: 'link' },
			{ title: 'Level', field: 'level' },
			{ title: 'Lease Start', field: 'leaseStart' },
			{ title: 'Lease End', field: 'leaseEnd' },
			{ title: 'Extension Option', field: 'extensionOption' },
			{ title: 'WAULT (y)', field: 'wault', type: 'numeric' },
			{ title: 'GLA (sqm)', field: 'gla', type: 'numeric' },
			{ title: 'Parking spaces', field: 'parking', type: 'numeric' },
			{ title: 'GRI p.a.', field: 'gri', type: 'numeric' },
			{ title: 'SC p.a.', field: 'sc', type: 'numeric' },
			{ title: 'Rent per sq ft', field: 'rent', type: 'numeric' },
			{ title: 'W (GRI)', field: 'wgri', type: 'numeric' },
			{ title: 'W (GLA)', field: 'wgla', type: 'numeric' },
		];
		let data = [];
		if (!!this.props.data) {
			this.props.data.tenants.forEach(tenant => data.push(tenant));
			for (let i = 0; i < data.length; i++) {
				data[i].gla = data[i].gla.toLocaleString();
				data[i].gri = `${data[i].gri.toLocaleString()}`;
				data[i].sc = `${data[i].sc.toLocaleString()}`;
				data[i].rent = `${data[i].rent.toLocaleString()}`;
				data[i].wgri = `${data[i].wgri}%`;
				data[i].wgla = `${data[i].wgla}%`;
			}
		}
		this.setState({ columns: columns, data: data });
	};

	render() {
		return (
			<Box mt="15px">
				<Box mb='15px' display='flex' justifyContent='space-between'>
					<Typography variant='h5'><strong>Rent Roll</strong></Typography>
					<Box display='flex'>
						<div style={{ marginRight: '15px' }}>
							<input
								color="primary"
								accept="image/*"
								type="file"
								onChange={false}
								id="rent-roll"
								style={{ display: 'none' }}
							/>
							<label htmlFor="rent-roll">
								<Button variant='contained' startIcon={<ImportExportIcon />} component="span">Export Rent Roll</Button>
							</label>
						</div>
						<div>
							<input
								color="primary"
								accept="image/*"
								type="file"
								onChange={false}
								id="rent-roll"
								style={{ display: 'none' }}
							/>
							<label htmlFor="rent-roll">
								<Button variant='contained' startIcon={<PublishIcon />} component="span">Upload Rent Roll</Button>
							</label>
						</div>
					</Box>
				</Box>
				<MaterialTable
					icons={tableIcons}
					options={{
						padding: 'dense',
						tableLayout: 'auto',
					}}
					title=""
					columns={this.state.columns}
					data={this.state.data}
					editable={{
						onRowAdd: newData =>
							new Promise((resolve, reject) => {
								setTimeout(() => {
									{
										const data = Array.from(this.state.data);
										data.push(newData);
										this.setState({ data }, () => resolve());
									}
									resolve();
								}, 1000);
							}),
						onRowUpdate: (newData, oldData) =>
							new Promise((resolve, reject) => {
								setTimeout(() => {
									{
										const data = Array.from(this.state.data);
										const index = data.indexOf(oldData);
										data[index] = newData;
										this.setState({ data }, () => resolve());
									}
									resolve();
								}, 1000);
							}),
						onRowDelete: oldData =>
							new Promise((resolve, reject) => {
								setTimeout(() => {
									{
										let data = Array.from(this.state.data);
										const index = data.indexOf(oldData);
										data.splice(index, 1);
										this.setState({ data }, () => resolve());
									}
									resolve();
								}, 1000);
							}),
					}}
				/>
			</Box >
		);
	}
}

export default Editable;
